import { motion } from "framer-motion";
import { SECTORS } from "@/lib/content";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="eyebrow" data-testid="section-eyebrow">{children}</p>
);

export const Marquee = () => {
  const items = [...SECTORS, ...SECTORS];
  return (
    <div className="relative overflow-hidden border-y border-gold/15 bg-navy-deep/70 py-5 marquee-mask" data-testid="sector-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {items.map((s, i) => (
          <span key={i} className="flex items-center whitespace-nowrap px-8 font-serif text-lg italic text-ivory/70">
            {s}
            <span className="ml-16 inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const SectionHead = ({ eyebrow, title, lead, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-serif text-2xl tracking-tight text-ivory sm:text-3xl lg:text-4xl" style={{ lineHeight: 1.15 }}>
        {title}
      </h2>
    </Reveal>
    {lead && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base font-light leading-relaxed text-slate-300 sm:text-lg">{lead}</p>
      </Reveal>
    )}
  </div>
);

export const PageHero = ({ eyebrow, title, lead, image }) => (
  <section className="relative overflow-hidden pt-40 pb-24" data-testid="page-hero">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover duotone opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/70 via-navy/80 to-navy" />
      </div>
    )}
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 max-w-3xl font-serif text-4xl tracking-tight text-ivory sm:text-5xl lg:text-6xl" style={{ lineHeight: 1.08 }}>
          {title}
        </h1>
      </Reveal>
      {lead && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-slate-300 sm:text-xl">{lead}</p>
        </Reveal>
      )}
    </div>
  </section>
);
